export default __webpack_public_path__ + "static/image/facebook.0b041cc0.png";